var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.983 11.953a7.123 7.123 0 0 0 0 10.063 7.123 7.123 0 0 0 10.063 0 7.123 7.123 0 0 0 0-10.063 7.123 7.123 0 0 0-10.063 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.952 6.922c-5.262 5.262-5.471 13.617-.754 19.202l-1.925 1.925c-1.313-.644-2.926-.506-4.08.502l-7.856 6.827a4.46 4.46 0 0 0-.272 6.557c1.857 1.857 4.888 1.697 6.546-.259l6.837-7.868c1.008-1.155 1.147-2.768.503-4.082l1.924-1.924c5.586 4.717 13.941 4.508 19.203-.754 5.549-5.55 5.549-14.577 0-20.126s-14.577-5.55-20.126 0m16.771 16.771c-3.699 3.7-9.718 3.7-13.417 0-3.699-3.699-3.699-9.718 0-13.417 3.7-3.7 9.718-3.7 13.418 0s3.699 9.718 0 13.417z"
  })));
};
export default SvgSearch;